import { styled, type Theme } from '@mui/material/styles';
import Tooltip, { tooltipClasses, type TooltipProps } from '@mui/material/Tooltip';

interface HtmlTooltipProps extends Omit<TooltipProps, 'classes'> {
  fontSize?: number | string;
}

interface StyledTooltipProps {
  theme: Theme;
  fontSize?: number | string;
}

const HtmlTooltip = styled(({ className, ...props }: HtmlTooltipProps & { className?: string }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, fontSize }: StyledTooltipProps) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#f5f5f9',
    '&::before': {
      border: `1px solid ${theme.palette.primary.main}`
    }
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: fontSize || theme.typography.pxToRem(12),
    border: '1px solid',
    borderColor: theme.palette.primary,
    whiteSpace: 'pre-wrap'
  }
}));

export default HtmlTooltip;
